import { usePermissions } from '../../../common/hooks/usePermissions';

function useSettlementPermission() {
  const { hasPermission } = usePermissions('SETTLEMENT_EDIT');
  return hasPermission;
}

export default useSettlementPermission;
